__turbopack_context__.v({
  "reactDatepickerEncapsulationGlobalStyles": "baseDatePicker-module-scss-module__QuIvaq__reactDatepickerEncapsulationGlobalStyles",
  "reactDatepickerPortalEncapsulationGlobalStyles": "baseDatePicker-module-scss-module__QuIvaq__reactDatepickerPortalEncapsulationGlobalStyles",
});
